<div *ngIf="modal?.title != nullModal.title" class="modal-backdrop">
  <div class="modal-container justify-items-center">
    <button class="modal-close p-2 flex flex-row justify-self-end">
      <i class="icon-close text-xl" (click)="close()"></i>
    </button>
    <div class="modal-content m-6">
      <div *ngIf="modal.type==type.Error || modal.type==type.Info" class="modal-icon">
        <img  src="{{imageUri}}" />
      </div> 
      <i *ngIf="modal.type==type.Info" class="icon-info-circle text-tone-06 text-xl"></i>
      <h2 class="modal-title">{{ modal.title }}</h2>
      <p class="modal-message">{{ modal.body }}</p>
      <button class="modal-action" (click)="close()">{{'saved.search.close' | transloco}}</button>
    </div>
  </div>
</div>
